import { Stack, Typography } from '@mui/material';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import { useTranslation } from 'react-i18next';
import { AppStyle } from '../../helpers/appStyle';
import { appStyleMode } from '../../helpers/clientConfigs';

export function EmptyGoodsList() {
  const { t } = useTranslation();

  return (
    <Stack
      direction="column"
      sx={{
        my: '10px',
        height: appStyleMode !== AppStyle.Mobile && '600px',
        backgroundColor: 'white',
        borderRadius: '15px',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Typography sx={{ fontSize: '20px', color: 'gray' }}>{t('services:emptyGoodsList')}</Typography>
      <SentimentDissatisfiedIcon sx={{ color: 'gray', height: '100px', width: '100px' }} />
    </Stack>
  );
}
